// extracted by mini-css-extract-plugin
export default {"Wrapper":"Navigation_Wrapper__RYqjx","Nav":"Navigation_Nav__FSG-9","active":"Navigation_active__bgAj+","lang":"Navigation_lang__c2mz7"};